import { Component, Input, OnInit } from '@angular/core';
import { RoleMSService } from '../../../../services/utils/roleMS.service';

@Component({
  selector: 'app-user-app-role-management',
  templateUrl: './user-app-role-management.component.html',
  styleUrls: ['./user-app-role-management.component.css']
})
export class UserAppRoleManagementComponent implements OnInit{
  @Input() rolesForUserApp: any[];
  @Input() activeRolesForUserApp: any[];
  @Input() userId: number;
  @Input() baseUrl: string;

  constructor(public srvRoleMS: RoleMSService) { }

  ngOnInit() {

  }

  manageRoles(checked: boolean, roleId: number) {
    if (checked) {
      this.srvRoleMS.addRoleForUser(this.baseUrl, {user_id: this.userId, role_id: roleId}).subscribe();
    } else {
      let userRoleId: number;
      this.srvRoleMS.getRolesForUser(this.baseUrl, this.userId).subscribe(
        userApps => {
          userRoleId = userApps.filter(app => app.role_id === roleId).map(filteredApp => filteredApp.id)[0];
          this.srvRoleMS.removeRoleForUser(this.baseUrl, userRoleId).subscribe();
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/company-admin/user-app-role-management/user-app-role-management.component.ts